// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__2jPKv"};